import React, { useState, useContext } from 'react'
import ReactDOM from 'react-dom'
import ModalWindow from '../../../layout/modalwindow/ModalWindow'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentFooter } from '../../../layout/Content'
import POListController from '../polist/POListController'
import POItemFooterStyle from './css/POItemFooterStyle'
import POController from '../po/POController'
import StockInController from '../../../stockin/stockin/StockInController'
import { appContext } from '../../../../App'
import { poItemControllerContext } from './POItemController'
import { dateYMD } from '../../../utilities/utilities'

function POItemFooter() {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const poItemController = useContext(poItemControllerContext)
  const { poItem, savePO, deletePO } = poItemController
  const [successMessage, setSuccessMessage] = useState(false)

  const onClickEdit = async (e) => {
    poItem.status = 'Unposted'
    poItem.action = 'edit'
    const po = await savePO(app, poItem)
    setContent(<POController poItem={po}/>)
  }

  const onClickDelete = (e) => {
    const onClick = async (button) => {
      if (button === 'Yes') {
        deletePO(app, poItem._id)
        .then(deleted_po => {
          if (deleted_po) {
            setSuccessMessage('Deleted successfully! Loading Purchase Orders List, please wait...')
            setTimeout(() => {
              setSuccessMessage('')
              setContent(<POListController />)
            }, 1000)
          }
        })
      }
      ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
    }

    ReactDOM.render (
      <ModalWindow
        id='mw-parent'
        header="Post"
        footer={null}>
        <div className='messagebox'>
          <div className='messagebox-content'>
            <div>Delete Purchase Order.</div>
            <br/>
            <p>Are you sure you want to continue?</p>
          </div>
          <div className='button-container'>
            <button onClick={() => onClick('No')} className='pospro-action-btn top-anchor'>No</button>
            <button onClick={() => onClick('Yes')} className='pospro-action-btn bottom-anchor'>Yes</button>
          </div>
        </div>
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onClickPost = (e) => {
    poItem.status = 'Posted'
    //if action is present delete it first to avoid double (edit) save
    delete poItem.action
    savePO(app, poItem)
    .then(po => {
      if (po) {
        setSuccessMessage('Posted successfully! Loading Purchase Order List, please wait...')
        setTimeout(() => {
          setSuccessMessage('')
          setContent(<POListController />)
        }, 1000)
      }
    })
  }

  const onClickReceive = async (e) => {
    // Delete the P.O. if this access_mode is 1
    if (poItem.access_mode) await deletePO(app, poItem._id)

    // Load this P.O. in StockIn
    const stockInItem = {
      status: 'On Process',
      warehouse: { name: '',  id: null },
      date_received: dateYMD(new Date(app.getClientDateTime())),
      received_by: '',
      reference_code: '',
      supplier_name: poItem.supplier,
      remarks: '',
      item_details: poItem.item_details
    }
    setContent(<StockInController stockInItem={stockInItem} />)
  }

  return (
    <ContentFooter>
      <div id="po-item-footer-container">
        <span style={{visibility: successMessage ? 'visible' : 'hidden'}} className='notification'>{successMessage}</span>
        <div className='translist-button-container'>
          <button className="pospro-action-btn"
            id="trans-list-edit"
            type="button"
            onClick={onClickEdit}>
            <FontAwesomeIcon icon='edit'/>&nbsp;Edit
          </button>
          <button className="pospro-action-btn"
            id="trans-list-delete"
            type="button"
            onClick={onClickDelete}>
            <FontAwesomeIcon icon='times'/>&nbsp;Delete
          </button>
          <button className="pospro-action-btn"
            id="trans-list-print"
            type="button"
            onClick={() => window.print()}>
            <FontAwesomeIcon icon='print'/>&nbsp;Print
          </button>
          <button className="pospro-action-btn"
            id="trans-list-btn"
            type="button"
            onClick={() => setContent(<POListController />)}>
            <FontAwesomeIcon icon='list-alt'/>&nbsp;Transactions List
          </button>
          <button className="pospro-action-btn"
            style={{display: (poItem.status === 'Unposted') ? 'block' : 'none'}}
            id="trans-list-post"
            type="button"
            onClick={onClickPost}>
            <FontAwesomeIcon icon='edit'/>&nbsp;Post
          </button>
          <button className="pospro-action-btn"
            style={{display: (poItem.status === 'Unposted') ? 'none' : 'block'}}
            id="trans-list-post"
            type="button"
            onClick={onClickReceive}>
            <FontAwesomeIcon icon='edit'/>&nbsp;Receive
          </button>
          <button className="pospro-action-btn"
            id="trans-list-post"
            type="button"
            onClick={() => setContent(<POController />)}>
            <FontAwesomeIcon icon='plus'/>&nbsp;Add New
          </button>
        </div>
      </div>
      <POItemFooterStyle />
    </ContentFooter>
  );
}

export default React.memo(POItemFooter)